import { SocialLink } from './SocialLink';
import { SocialLinkProps } from './SocialLink';
import FacebookSVG from '../../assets/imgs/icon/facebook-circle.svg';
import TwitterSVG from '../../assets/imgs/icon/x-twitter-orange.svg';
import InstagramSVG from '../../assets/imgs/icon/instagram.svg';

const links: SocialLinkProps[] = [
	{
		icon: FacebookSVG,
		url: 'https://www.facebook.com/BiggbyCoffee.Bhappy'
	},
	{
		url: 'https://x.com/BIGGBYCOFFEE',
		icon: TwitterSVG,
		padded: true
	},
	{
		url: 'https://instagram.com/biggbycoffee',
		icon: InstagramSVG,
		padded: true
	}
];

export type SocialLinksProps = {
	withLabel?: boolean;
};

export const SocialLinks: React.FC<SocialLinksProps> = ({
	withLabel = false
}) => (
	<ul className="social-links d-flex list-unstyled h-100 align-items-center mb-0 py-2">
		{withLabel && <li className="text-white pr-3">B Connected</li>}

		{links.map((link, key) => (
			<SocialLink key={key} {...link} />
		))}
	</ul>
);
